import _ from 'underscore';
import PropTypes from 'prop-types';
import { getImageUrl } from '@culture/common-helpers/cultureUtils';
import { useContext } from 'react';
import { getAudioFileUrl } from '@culture/utils/helpers/files';
import getConfig from 'next/config';
import { ImageFormatContext } from 'contexts/ImageFormatContext';
import { InteractiveResultPropType } from 'propTypes/common';
import AudioPlayer from 'components/Audio/AudioPlayer';
import StyledContentImage from 'components/StyledContent/components/StyledContentImage';

import ShareButtons from 'components/ShareButtons';
// eslint-disable-next-line import/no-cycle
import StyledContentBlock from 'components/StyledContent/components/StyledContentBlock';
import styles from './styles.module.scss';

const { publicRuntimeConfig } = getConfig();

const Results = ({
	score,
	resultMetadata,
	questionsAmount,
	showCorrectAnswersAmount
}) => {
	const { audio, file, sharingImage, jsonText } = resultMetadata;

	const imageFormat = useContext(ImageFormatContext);
	const imageSrc =
		file &&
		getImageUrl(file, {
			format: imageFormat,
			params: {
				crop: 'fill',
				gravity: 'center'
			}
		});

	const sharingImageSrc =
		sharingImage &&
		getImageUrl(sharingImage, {
			format: imageFormat,
			params: {
				crop: 'fill',
				gravity: 'center'
			}
		});

	const trackUrl =
		!_.isEmpty(audio) &&
		getAudioFileUrl(audio, {
			config: publicRuntimeConfig
		});
	return (
		<div className={styles.Results}>
			<div className={styles.Results__Header}>
				<span className={styles.Results__Heading}>Результат</span>
				<div className={styles.Results__ShareBlock}>
					Поделиться:
					<ShareButtons
						theme="horizontal"
						customSocialButtonsOrder="vkontakte,odnoklassniki,telegram,whatsapp"
						imageSrc={sharingImageSrc}
					/>
				</div>
			</div>
			{!!audio && (
				<AudioPlayer
					trackSrc={trackUrl}
					className={styles.Results__Audio}
					autoPlay={false}
				/>
			)}
			{!!imageSrc && (
				<StyledContentImage src={imageSrc} className={styles.Results__Image} />
			)}
			<div className={styles.Results__Description}>
				{jsonText.map((block) => (
					<StyledContentBlock
						key={block?.text?.slice(0, 15) || block?.type}
						{...block}
					/>
				))}
			</div>
			{showCorrectAnswersAmount && (
				<div className={styles.Results__Info}>
					<span className={styles.Results__CountText}>
						Количество правильных ответов:
					</span>
					<span className={styles.Results__Count}>
						{`${score}/${questionsAmount}`}
					</span>
				</div>
			)}
		</div>
	);
};

Results.propTypes = {
	score: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
	questionsAmount: PropTypes.number.isRequired,
	resultMetadata: InteractiveResultPropType.isRequired,
	showCorrectAnswersAmount: PropTypes.bool
};

export default Results;
